<template>
  <b-row
    class="p-0 m-0"
    v-bind:class="{
      defaultCard: item.id == (selectedCard ? selectedCard.id : null),
    }"
  >
    <b-col
      class="p-4 align-self-center card-image"
      @click.prevent="
        () => {
          $emit('cardSelected', item);
        }
      "
    >
      <CardSvgLarge :cardType="item.cardType"></CardSvgLarge>

      <span class="pill">Selected</span>
    </b-col>
    <b-col
      class="p-4 text-right align-self-center"
      md="auto"
      @click.prevent="
        () => {
          $emit('cardSelected', item);
        }
      "
    >
      <div class="stat-box-title">Card Number</div>
      <div class="stat-box-body">
        {{ item.description }}
      </div>
    </b-col>
    <b-col
      class="p-4 text-right align-self-center"
      md="auto"
      @click.prevent="
        () => {
          $emit('cardSelected', item);
        }
      "
    >
      <div class="stat-box-title">Exp Date</div>
      <div class="stat-box-body">{{ item.expMonth }}/{{ item.expYear }}</div>
    </b-col>
    <b-col
      class="p-4 text-right align-self-center card-list-remove"
      @click.prevent="$emit('deleteCard', item)"
    >
      <i
        class="fa-solid fa-trash-can-xmark"
        v-b-tooltip.hover
        title="Remove Card"
      ></i>
    </b-col>
  </b-row>
</template>

<script>
import CardSvgLarge from "./CardSvgLarge";
export default {
  props: { item: null, selectedCard: null },
  components: { CardSvgLarge },
};
</script>

<style scoped>
.defaultCard .stat-box-title,
.defaultCard .stat-box-body,
.defaultCard .fa-trash-can-xmark {
  color: #fff;
}

.defaultCard .card-list-remove {
  cursor: pointer;
}

.stat-box-body {
  font-size: 0.8em;
}

.defaultCard {
  background: #36d1dc; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to left,
    #5b86e5,
    #36d1dc
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to left,
    #5b86e5,
    #36d1dc
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}

.pill-card {
  display: none !important;
}

.selectedCard .pill-card.pill-selected,
.defaultCard .pill-card.pill-default {
  display: inline-block !important;
}

.pill {
  font-size: 0.6em;
  border: solid 1px #fff;
  font-weight: 600;
  color: #fff;
  padding: 0 8px;
  border-radius: 3px;
  margin-top: 10px;
  margin-right: 10px;
  display: inline-block;
  text-align: center;
}

.card-list-remove:hover .fa-trash-can-xmark {
  color: #f5365c;
}

.pill {
  display: none;
}

.defaultCard .pill {
  display: block;
  width: 55px;
}
</style>
